/**
 * Detects if the browser is Chromium-based (Chrome, Edge, Brave, Opera, etc.)
 * Chromium browsers support the preferCurrentTab flag for getDisplayMedia
 */
export function isChromiumBrowser(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent.toLowerCase();

  // Check for Chromium-based browsers
  // Note: Edge (Chromium) also includes "chrome" in UA
  return (
    userAgent.includes('chrome') ||
    userAgent.includes('chromium') ||
    userAgent.includes('edg/') || // Edge Chromium
    userAgent.includes('brave') ||
    userAgent.includes('opera') ||
    userAgent.includes('opr/')
  );
}

/**
 * Checks if the browser needs manual tab selection for screen recording
 * Returns true for Firefox, Safari, and other non-Chromium browsers
 */
export function needsManualTabSelection(): boolean {
  return !isChromiumBrowser();
}

/**
 * Returns true only when the browser exposes the getDisplayMedia API
 * required to run a User Test (screen recording). Safe to call during
 * SSR — returns false server-side because there is no navigator to
 * inspect. Callers that render server-side should gate this behind a
 * `mounted` flag so the unsupported-browser warning doesn't flash for
 * supported clients during hydration.
 */
export function supportsDisplayMedia(): boolean {
  if (typeof window === 'undefined') return false;
  return typeof navigator?.mediaDevices?.getDisplayMedia === 'function';
}
